// extracted by mini-css-extract-plugin
export var banner = "_i8-0";
export var closeButton = "_i8-2";
export var greenCheckmark = "_i8-3";
export var hereLink = "_i8-4";
export var titleIcon = "_i8-1";